module.exports = __webpack_public_path__ + "static/media/a.044cd019.png";